import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const WORK_SITES_SUCCESS = 'LOAD_WORK_SITES_SUCCESS';
export const WORK_SITES_FAIL = 'LOAD_WORK_SITES_FAIL';
export const WORK_SITES_REQUEST = 'LOAD_WORK_SITES_REQUEST';

export const UPDATE_SUCCESS = 'UPDATE_WORK_SITES_SUCCESS';
export const UPDATE_FAIL = 'UPDATE_WORK_SITES_FAIL';
export const UPDATE_REQUEST = 'UPDATE_WORK_SITES_REQUEST';

export const SUBMIT_SUCCESS = 'SUBMIT_WORK_SITES_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_WORK_SITES_FAIL';
export const SUBMIT_REQUEST = 'SUBMIT_WORK_SITES_REQUEST';

export const DELETE_SUCCESS = 'DELETE_WORK_SITES_SUCCESS';
export const DELETE_FAIL = 'DELETE_WORK_SITES_FAIL';
export const DELETE_REQUEST = 'DELETE_WORK_SITES_REQUEST';


const loadworkSitesRequest = () => ({ type: WORK_SITES_REQUEST });
const loadworkSitesFail = (error) => ({ type: WORK_SITES_FAIL, error });
const loadworkSitesSuccess = (workSites) => ({ type: WORK_SITES_SUCCESS, workSites });

const submitworkSitesRequest = () => ({ type: SUBMIT_REQUEST });
const submitworkSitesFail = (error) => ({ type: SUBMIT_FAIL, error });
const submitworkSitesSuccess = (workSite) => ({ type: SUBMIT_SUCCESS, workSite });

const updateworkSitesRequest = () => ({ type: UPDATE_REQUEST });
const updateworkSitesFail = (error) => ({ type: UPDATE_FAIL, error });
const updateworkSitesSuccess = (workSite) => ({ type: UPDATE_SUCCESS, workSite });

const deleteworkSitesRequest = () => ({ type: DELETE_REQUEST });
const deleteworkSitesFail = (error) => ({ type: DELETE_FAIL, error });
const deleteworkSitesSuccess = (workSiteId) => ({ type: DELETE_SUCCESS, workSiteId });


export const loadWorkSites = () => (dispatch) => {
  dispatch(loadworkSitesRequest());
  return communicate({
    url: 'Worksites', method: 'get', getParams: '?isDeleted=false'
  }).then((response) => {
    dispatch(loadworkSitesSuccess(response.data.Data));
  }).catch((error) => {
    dispatch(loadworkSitesFail('Error downloading work sites'));
    toastrError(error);
  });
};

export const submitWorkSite = (workSite) => (dispatch) => {
  dispatch(submitworkSitesRequest());
  return communicate({
    url: 'Worksites', method: 'post', data: workSite
  }).then((response) => {
    toastrSuccess(response);
    return dispatch(submitworkSitesSuccess(response.data.Data));
  }).catch((error) => {
    toastrError(error);
    dispatch(submitworkSitesFail('Error submitting work site'));
  });
};

export const updateWorkSite = (workSite) => (dispatch) => {
  dispatch(updateworkSitesRequest());
  return communicate({
    url: 'Worksites', method: 'put', data: workSite
  }).then((response) => {
    toastrSuccess(response);
    return dispatch(updateworkSitesSuccess(response.data.Data));
  }).catch((error) => {
    toastrError(error);
    dispatch(updateworkSitesFail('Error updating work site'));
  });
};

export const deleteWorkSite = (request) => (dispatch) => {
  dispatch(deleteworkSitesRequest());
  return communicate({
    url: 'Worksites', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(request)
  }).then((response) => {
    toastrSuccess(response);
    dispatch(deleteworkSitesSuccess(request.id));
  }).catch((error) => {
    toastrError(error);
    dispatch(deleteworkSitesFail('Error deleting work site'));
  });
};
